import React from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import { useStyles } from "./styles";

interface ActivateCompanyDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ActivateCompanyDialog: React.FC<ActivateCompanyDialogProps> = ({ open, onClose, onConfirm }) => {
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      data-testid="dm-activate-company-instruction-modal"
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      maxWidth="xs"
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle>
        <Typography variant="h6" component="h2">
          Update Client Status to Active?
        </Typography>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography className={classes.dialogTypography}>
          <strong>Reminder:</strong> SVB must have permissible purpose to 
          maintain an active Codat connection to a client’s 
          accounting software. Only establish an active 
          connection if they <strong>have an active loan</strong> or are <strong>in the 
          process of applying for one.</strong>
        </Typography>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button className={classes.dialogButton} variant="text" color="primary" onClick={onClose}>
          CANCEL
        </Button>
        <Button className={classes.dialogButton} variant="text" color="primary" onClick={onConfirm}>
          CONFIRM
        </Button>
      </DialogActions>
    </Dialog>
  )
}
export default ActivateCompanyDialog